import 'regenerator-runtime/runtime.js'
import $ from 'jquery'
import 'bootstrap'
window.jQuery = window.$ = $

require('@fancyapps/fancybox')
require('jquery-migrate')
require('imagesloaded')
require('select2')

import smoothscroll from 'smoothscroll-polyfill'
import bsCustomFileInput from 'bs-custom-file-input'

import './setupJQuery'
import './ajaxCollapseAfter'
import './slider'
import './longText'
import './search'
import './ajaxForm'
import { refreshCaptchaButton } from './ajaxForm'
import { initIndexNavigation } from './openSection'
import initSearchFilter from './searchFilter'
import ajaxLoad from './loadRelated'
import userAgreement from './userAgreement'
import welcomeText from './welcomeText'
import './frontpageRelatedItems'
import './searchableFilter'
import initFancybox from './fancyboxUtils'
import './nestedCheckboxes'
import './clearableInput'
import './videoUtils.js'
import setupAnalyticsTags from './analytics'
import './vod.js'
import './carousels'
import './carousels2'
import './ajaxPagination'
import './ajaxGet'
import './profile'
import './stripe.js'
import './alpineHelpers'
import initSticky from './initSticky'
import initIndex from './initIndex'

// global

function loadBubbles() {
  return import(/* webpackChunkName: "bubbles" */ './bubbles')
    .then(() => {})
    .catch(err => console.log('error loading bubbles', err))
}

function loadDateRangeWidget() {
  return import(/* webpackChunkName: "dateRangeWidget" */ './daterangewidget')
    .then(() => {
      $('input.daterange').dateRangeWidget()
    })
    .catch(err => console.log('error loading daterangewidget', err))
}

$(function() {
  initIndexNavigation()
  smoothscroll.polyfill()
  userAgreement()
  welcomeText()
  refreshCaptchaButton()
  bsCustomFileInput.init()
  setupAnalyticsTags()

  window.isMobile = $.fancybox.isMobile

  if (window.screen.width > 767 && $('#frontpage__bubbles').length) {
    loadBubbles()
  }

  if ($('input.daterange').length > 0) {
    loadDateRangeWidget()
  }

  if ($('[data-image-crop]').length !== 0) {
    import(/* webpackChunkName: "cropperHelper" */ './cropperHelper')
      .then(() => {})
      .catch(err => console.log('error loading cropperHelper', err))
  }

  // note: fix for ipad pdf in iframe
  // https://trello.com/c/GYYHQHJy/1311-pdf-download-advanced-search-zelo-dolgo-traja
  window.iOS =
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !window.MSStream

  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="ajax-collapse-after"]').ajaxCollapseAfter()
  $('[data-toggle="long-text"]').longText()
  $('[data-toggle="slider"]').slider()

  $('[data-gallery-after-login]').prepareVideosForLogin()

  initFancybox()

  $('[data-toggle="open-section"]').openSection()

  $('[data-toggle="ajax-load-content"]').each((index, el) => {
    ajaxLoad(el).then(() => {
      refreshCaptchaButton()
    })
  })

  $('[data-frontpage-related-items]').frontpageRelatedItems()

  $(
    '.filter-field--searchable > div, .form-checkboxes-multiple--searchable'
  ).searchableFilter()
  $('.nested-checkboxes').nestedCheckboxes()
  initSearchFilter()

  $('[data-add-to-wishlist]').activateWishlist()
  $('[data-add-to-playlist]').activatePlaylist()
  $('body').addClass('body--initialized')
  $('body').removeClass('preload')

  $.fn.select2.defaults.set('theme', 'bootstrap')
  $('.select2').select2()

  $(document).on('submit', 'form:not([data-custom-submit])', function() {
    $('button[type=submit], input[type=submit]', this).attr(
      'disabled',
      'disabled'
    )
  })

  function addUrlParameter(name, value) {
    var searchParams = new URLSearchParams(window.location.search)
    searchParams.set(name, value)
    window.location.search = searchParams.toString()
  }

  function constructURLForFormParams(url, form, name, value) {
    const urlObject = new URL(window.location)
    const searchParams = new URLSearchParams(form.serialize())
    searchParams.set(name, value)
    urlObject.pathname = url
    urlObject.search = searchParams.toString()
    return urlObject.href
  }

  document.querySelectorAll('[data-sticky]').forEach(el => {
    initSticky(el)
  })

  initIndex()

  window.addUrlParameter = addUrlParameter
  window.constructURLForFormParams = constructURLForFormParams
})
